<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch01-7">
<p class="centerImage"><img alt="images" id="img18" src="images/img18.jpg" style="max-width:100%;"/></p>
<p class="caption"><em class="italic">Theodore Gardelle disposing of pieces of the body of his landlady, Mrs King. </em><span class="fontS">Author’s collection</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08a_Fouldeeds_ch017.vue?a5609180